import { render } from "./FooterLayout.vue?vue&type=template&id=e87f5bca&scoped=true"
const script = {}

import "./FooterLayout.vue?vue&type=style&index=0&id=e87f5bca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87f5bca"]])

export default __exports__